























































import {Vue, Component} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service"
import {VrstaOdrzavanja} from "@/services/BackendProxies";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class VrsteOdrzavanja extends mixins(ComponentBaseMixin) {
    columns = [];
    tableOptions = {
        search: true,
        pagination: true,
        onClickRow: row => this.onClickRow(row)
    };
    vrsteOdrzavanja = [];
    vrstaOdrzavanja = new VrstaOdrzavanja();

    async created() {
        this.columns = [
            {field: 'oznaka', width: 50, title: this.$i18n.t('oznaka')},
            {field: 'naziv', title: this.$i18n.t('naziv')},
            {
                field: 'preventivno', width: 50,
                title: this.$i18n.t('preventivno'),
                formatter: (value) => value ? this.$i18n.t('da') : this.$i18n.t('ne')
            },
        ];
        this.vrsteOdrzavanja = await this.loadData(() => dataProxy.vratiVrsteOdrzavanja())();
    }

    novaVrstaOdrzavanja() {
        this.vrstaOdrzavanja = new VrstaOdrzavanja();
        (<HTMLElement>this.$refs.oznaka).focus();
    }

    async sacuvajVrstuOdrzavanja() {
        const valid = await (<any>this.$refs.form).validate();
        if (valid) {
            this.vrstaOdrzavanja = await this.saveData(() => dataProxy.savucajVrstuOdrzavanja(this.vrstaOdrzavanja))();
            this.vrsteOdrzavanja = await dataProxy.vratiVrsteOdrzavanja();
        }
    }

    async obrisiVrstuOdrzavanja() {
        const valid = await this.confirmationNeeded('da li zelite da obrisete vrstu odrzavanja');
        if (valid) {
            await this.deleteData(() => dataProxy.obrisiVrstuOdrzavanja(this.vrstaOdrzavanja.id))();
            this.vrsteOdrzavanja = await dataProxy.vratiVrsteOdrzavanja();
            this.novaVrstaOdrzavanja();
        }
    }

    onClickRow(row) {
        this.vrstaOdrzavanja = row;
    }

}
